import * as React from 'react';
import {NavLink} from "react-router-dom";
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import {DrawerBase, DrawerHeader} from "./DrawerBase";
import styles from './DrawerMenu.module.scss';
import BarChartIcon from '@mui/icons-material/BarChart';
import SearchIcon from '@mui/icons-material/Search';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import PersonIcon from '@mui/icons-material/Person';
import {OverridableComponent} from "@mui/material/OverridableComponent";
import {SvgIconTypeMap} from "@mui/material/SvgIcon/SvgIcon";
import logo from '../../../resources/images/logo.png';
import {UserMenu} from '../../auth/UserMenu';


const links:  {label: string, icon: OverridableComponent<SvgIconTypeMap>, to: string}[] = [
    {label: 'Home', icon: BarChartIcon, to: '/'},
    {label: 'Search', icon: SearchIcon, to: 'search'},
    {label: 'My Library', icon: LibraryMusicIcon, to: 'library'},
    {label: 'Profile', icon: PersonIcon, to: 'profile'},
];

export interface DrawerMenuProps extends React.PropsWithChildren{}

export const DrawerMenu: React.FC<DrawerMenuProps> = () => {
    const [open, setOpen] = React.useState(true);

    const toggleDrawer = () => {
        setOpen(prevState => !prevState);
    }

    return (
        <DrawerBase variant="permanent" open={open}>
            <DrawerHeader>
                <img src={logo} alt="KeePlaying" className={styles.drawerMenu__logo}/>
                <IconButton onClick={toggleDrawer}>
                    {/*{open ? <ChevronLeftIcon/> : <MenuIcon/>}*/}
                </IconButton>
            </DrawerHeader>
            <Divider/>
            <List className={styles.drawerMenu__links}>
                {links.map(link => <NavLink
                    key={link.label}
                    to={link.to}
                    className={styles.drawerMenu__link}>
                    <link.icon className={styles.drawerMenu__icon}/>
                    <div className={styles.drawerMenu__label}>{link.label}</div>
                </NavLink>)}
            </List>
            <div className={styles.drawerMenu__footer}>
                <UserMenu/>
            </div>
        </DrawerBase>
    );
}
